/**
 * 子系统接口
 */
export default {
  getSSOToken: {
    url: '/api/auth/login',
    method: 'GET',
  },
}
